import { RouteObject, Navigate } from 'react-router-dom';

import { ProtectedRoute } from '@components/ProtectedRoute';
import { useAuthContext } from '@auth_module/context/AuthContext';

import { AccountPage } from '@account_module/pages/AccountPage';
import { SelfServeApiPage } from '@account_module/pages/SelfServeApiPage';
import { MegaphoneOnboardPage } from '@account_module/pages/MegaphoneOnboardPage';
import { SettingsPage } from '@account_module/pages/SettingsPage';
import { AccountSettingsProvider } from '@account_module/context/AccountSettingsContext';
import { useFeatureFlag, FEATURE_FLAG } from '@auth_module/hooks/useFeatureFlag';
import { MegaphoneOnboardProvider } from '@account_module/context/MegaphoneOnboardContext';
import { useIntegration } from '@account_module/hooks/useIntegrations';
import { useUser } from '@auth_module/hooks/useUser';
import { LayoutProvider } from '@insights_module/context/LayoutContext';

export const _accountRoutes = (): RouteObject[] => {
  const { auth } = useAuthContext();
  const { organization } = useUser();
  const { shouldRedirectToOnboarding } = useIntegration();
  const { isEnabled: isSelfOnboardingEnabled } = useFeatureFlag(
    FEATURE_FLAG.MEGAPHONE_SELF_ONBOARDING
  );

  return [
    {
      path: '/account',
      element: (
        <LayoutProvider>
          <AccountSettingsProvider>
            <ProtectedRoute redirectPath='/' isAllowed={!!auth.token} />
          </AccountSettingsProvider>
        </LayoutProvider>
      ),
      children: [
        {
          index: true,
          element: <AccountPage />,
        },
        {
          path: '/account/settings',
          element: <SettingsPage />,
        },
        {
          path: '/account/self-service-api',
          element: (
            <ProtectedRoute
              redirectPath='/dashboard'
              isAllowed={
                organization?.type === 'customer' || organization?.type === 'customer-free'
              }>
              <SelfServeApiPage />
            </ProtectedRoute>
          ),
        },
        {
          path: '/account/onboarding/megaphone',
          element: (
            <ProtectedRoute
              redirectPath='/account/settings'
              isAllowed={isSelfOnboardingEnabled && shouldRedirectToOnboarding}>
              <MegaphoneOnboardProvider>
                <MegaphoneOnboardPage />
              </MegaphoneOnboardProvider>
            </ProtectedRoute>
          ),
        },
        {
          path: '/account/*',
          element: <Navigate to='/account' />,
        },
      ],
    },
  ];
};
